import { SnackbarProvider } from 'notistack';

import Portal from '@mui/material/Portal';

import alertTemplate from '~/components/Alerts/AlertTemplate';
import TenantProvider from '~/components/TenantProvider';
import { AddSiteProvider } from '~/scenes/AddSetupSiteFlows/context/AddSiteContext';

import QueryFeatureAlertBar from './components/Alerts/QueryFeatureAlertBar';
import Main from './components/Main';
import MainRoutes from './MainRoutes';

const App = () => {
  return (
    <TenantProvider>
      <Portal>
        <SnackbarProvider
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          Components={{ alertTemplate }}
          style={{ marginTop: '60px' }}
        >
          <QueryFeatureAlertBar />
        </SnackbarProvider>
      </Portal>

      <Main>
        <AddSiteProvider>
          <MainRoutes />
        </AddSiteProvider>
      </Main>
    </TenantProvider>
  );
};

export default App;
